export default function() {
    return {
        questions: [],
        showDeleteConfirmationModal: false,
        deleteQuestion: null,
        sortingChanged: false,
        fields: [
            {
                key: 'question',
                label: 'Pergunta'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
